<template>
    <div>
        <Header/>
        <div class="OrganizationJoinStep2">
            <div class="stepTop">
                <img src="../../assets/images/homeImg/组 11@2x.png" height="240" width="3840"/>
                <div class="rz-type">养老机构入驻</div>
            </div>
            <div class="progressBar">
                <MyStepBar :stepData="stepData" :status="3"/>
            </div>
            <div class="form-box">
                <a-form :form="form">
                    <div class="form-item">
                        <a-form-item v-bind="formItemLayout" label="养老机构账号">
                            <a-input
                                    placeholder="机构账号不能为空"
                                    v-decorator="[
                'orgAccount',
                {
                  trigger: 'blur',
                  rules: [
                    {
                      required: true,
                      validator: this.checkExist.bind(this),
                    },
                  ],
                  initialValue:formData.shopInfo.orgAccount,
                },
              ]"
                            />
                            <div class="fileTipBox202005062">此帐号为日后登录并管理机构管理中心时使用，注册后不可修改，请牢记。默认密码123456</div>
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="养老机构名称" style="margin-top: 0.33rem">
                            <a-input
                                    placeholder="请输入机构名称"
                                    v-decorator="[
                'orgName',
                {
                  trigger: 'blur',
                  rules: [
                    {
                      required: true,
                      validator: this.checkExistName.bind(this),
                    },
                  ],
                  initialValue: formData.shopInfo.orgName,
                },
              ]"
                            />
                            <div class="fileTipBox202005062">养老机构名称注册后不可修改，请认真填写</div>
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="养老机构性质" class="property">
                            <a-radio-group
                                    v-decorator="[
                'fnre',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择机构性质',
                    },
                  ],
                  initialValue: initialValue.fnre,
                },
              ]"
                            >
                                <a-radio v-for="item in fnreType" :value="item.key" :key="item.key">{{ item.value }}
                                </a-radio>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="创建时间">
                            <a-date-picker
                                    style="width: 3.53rem"
                                    placeholder="请选择机构创建时间"
                                    v-decorator="[
                'createTime',
                {
                  rules: [
                    {
                      required: true,
                      message: '机构创建时间不能为空',
                    },
                  ],
                  initialValue: formData.expansionInfo.createTime? moment(formData.expansionInfo.createTime, 'YYYY-MM-DD'): null,
                },
              ]"
                            />
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="养老机构类别">
                            <a-select
                                    style="width: 3.53rem"
                                    cleanable
                                    placeholder="请选择机构类别"
                                    @change="ndewichange"
                                    v-decorator="[
                'ndewi',
                {
                  rules: [
                    {
                      required: true,
                      message: '机构类别不能为空',
                    },
                  ],
                  initialValue: initialValue.ndewi,
                },
              ]"
                            >
                                <a-select-option

                                        v-for="item in orgType"
                                        :value="item.key"
                                        :key="item.key"
                                ><span style="font-size: 0.14rem">{{ item.value }}</span></a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="养老模式">
                            <a-select
                                    style="width: 3.53rem"
                                    mode="multiple"
                                    placeholder="请选择机构养老模式"
                                    v-decorator="[
                'orgForm',
                {
                  rules: [
                    {
                      required: true,
                      message: '机构养老模式不能为空',
                    },
                  ],
                  initialValue: initialValue.orgForm,
                },
              ]"
                            >
                                <a-select-option
                                        style="font-size: 0.16rem"
                                        v-for="item in serviceType"
                                        :value="item.key"
                                        :key="item.key"
                                >{{ item.value }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        <div class="imageUpload">
                            <a-form-item v-bind="formItemLayout" label="封面图片" style="height: 1.05rem;">
                                <a-upload
                                        name="file"
                                        :customRequest="uploadCoverAll"
                                        :remove="uploadCoverRemove"
                                        @preview="handlePicturePreview"
                                        list-type="picture-card"
                                        :file-list="uploadCoverFileList"
                                        v-decorator="[
                'coverImage',
                {
                  rules: [
                    {
                      required: true,
                      validator: this.uploadCoverFileCheck.bind(this),
                    },
                  ],
                },
              ]"
                                >
                                    <div v-if="uploadCoverFileList.length < 1">
                                        <a-icon type="plus"/>
                                        <div class="ant-upload-text">上传封面</div>
                                    </div>
                                </a-upload>
                            </a-form-item>
                        </div>
                        <a-form-item v-bind="formItemLayout" label="机构图集">
                            <a-upload
                                    name="file"
                                    :customRequest="uploadAtlasAll"
                                    :remove="uploadAtlasRemove"
                                    :multiple="true"
                                    @preview="handlePicturePreview"
                                    list-type="picture-card"
                                    :file-list="uploadAtlasList"
                                    v-decorator="[
                'imageUrl',
                {
                  rules: [
                    {
                      required: false,
                      validator: this.uploadCoverFileCheckOne.bind(this),
                    },
                  ],
                },
              ]"
                            >
                                <div>
                                    <a-icon type="plus"/>
                                    <div class="ant-upload-text">上传图集</div>
                                </div>

                            </a-upload>
                            <p v-if="uploadAtlasList.length<3" class="fileTipBox202005062" style="top: 0.13rem">
                                机构图集也可以在养老机构审批通过后再完善</p>

                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="养老机构所在地">
                            <a-cascader
                                    :options="options"
                                    :loadData="loadData"
                                    style="width: 3.53rem"
                                    :placeholder="addrPlaceHolder"
                                    @change="selectAddress"
                                    v-decorator="[
                'freoij',
                {
                   trigger: 'change',
                  rules: [
                    {
                      required: true,
                      validator: this.addrcheck.bind(this),
                    },
                  ],
                initialValue: formData.shopInfo.shopAddress,
                },
              ]"
                            />
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="养老机构详细地址">
                            <a-input
                                    placeholder="请输入机构详细地址"
                                    v-decorator="[
                'addressDetail',
                {
                  rules: [
                    {
                      required: true,
                      message: '机构详细地址不能为空',
                    },
                  ],
                  initialValue: formData.shopInfo.addressDetail,
                },
              ]"
                            />
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="养老机构电话">
                            <a-input
                                    placeholder="请输入养老机构电话,如010-12345678,13812345678,0044-1111111"
                                    v-decorator="[
                'orgTel',
                {
                  rules: [
                    {
                      required: true,
                      validator: this.phoneCheck.bind(this),
                    },
                  ],
                  initialValue: formData.shopInfo.orgTel,
                },
              ]"
                            />
                        </a-form-item>
                    </div>

                    <div class="detailsTheData">
                        <div class="excursion" style="padding-left: 0.2rem;">
                            <a-form-item v-bind="formItemLayoutThree" label="占地面积（平方）" style="margin-bottom: 0.2rem">
                                <a-input
                                        style="width: 1.67rem;"
                                        @blur="numberkeyup"
                                        placeholder="请输入占地面积"
                                        v-decorator="[
                'areaSize',
                {
                  rules: [
                    {
                      required: true,
                      message: '机构占地面积不能为空',
                    },
                  ],
                  initialValue: formData.expansionInfo.areaSize || null,
                },
              ]"
                                >
                                    <span slot="suffix" title="Extra information">m&sup2;</span>
                                </a-input>
                            </a-form-item>

                            <a-form-item v-bind="formItemLayoutThree" label="最低价格（元）">
                                <a-input
                                        placeholder="请输入最低价格"
                                        addon-before="￥"
                                        v-decorator="[
                'lowestPrice',
                {
                  trigger: 'blur',
                  rules: [
                    {
                      required: true,
                      validator: this.formater.bind(this),
                    },
                  ],
                  initialValue: formData.shopInfo.lowestPrice,
                },
              ]"
                                />
                            </a-form-item>
                        </div>
                        <div class="excursion">
                            <a-form-item v-bind="formItemLayout" label="床位数">
                                <a-input-number
                                        style="width:1.67rem; height: 0.4rem;line-height: 0.4rem"
                                        type="number"
                                        :min=0
                                        placeholder="请输入床位数"
                                        v-decorator="[
                'bedNum',
                {
                  rules: [
                    {
                      required: true,
                      message: '机构床位数不能为空',
                    },
                  ],
                  initialValue: formData.shopInfo.bedNum,
                },
              ]"
                                />
                            </a-form-item>
                            <a-form-item v-bind="formItemLayout" label="最高价格（元）">
                                <a-input
                                        addon-before="￥"
                                        placeholder="请输入最高价格"
                                        v-decorator="[
                'highestPrice',
                {
                  trigger: 'blur',
                  rules: [
                    {
                      required: true,
                      validator: this.maxThanMin.bind(this),
                    },
                  ],
                  initialValue: formData.shopInfo.highestPrice,
                },
              ]"
                                />
                            </a-form-item>
                        </div>


                    </div>
                    <div class="form-item">
                        <a-form-item v-bind="formItemLayout" label="收住对象" class="admittedObject">
                            <a-checkbox-group
                                    :options="plainOptions"
                                    v-decorator="[
                'refcev',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择机构收住对象',
                    },
                  ],
                  initialValue: initialValue.refcev,
                },
              ]"
                            />
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="营业时间">
                            <a-radio-group
                                    @change="onBusinessHoursChange"
                                    v-decorator="[
                'businessHours',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择机构营业时间！',
                    },
                    {
                      validator: this.checkBusinessTime.bind(this),
                    },
                  ],
                  initialValue: needSetBusinessTime,
                },
              ]"
                            >
                                <a-radio :value="false">全天</a-radio>
                                <a-radio :value="true">自定义</a-radio>
                                <div v-show="needSetBusinessTime" style="margin-top: 0.1rem">
                                    <a-time-picker
                                            :default-open-value="moment('00:00', 'HH:mm')"
                                            placeholder="开始时间"
                                            @change="startTime"
                                            format="HH:mm"
                                            v-decorator="[
                    'opentime',
                    {
                      initialValue: formData.shopInfo.openTime ? moment(formData.shopInfo.openTime, 'HH:mm:ss'): moment('00:00:00', 'HH:mm:ss'),
                    },
                  ]"
                                    />
                                    -
                                    <a-time-picker
                                            :default-open-value="moment('00:00', 'HH:mm')"
                                            placeholder="结束时间"
                                            @change="endTime"
                                            format="HH:mm"
                                            v-decorator="[
                    'closetime',
                    {
                      initialValue: formData.shopInfo.closeTime
                        ? moment(formData.shopInfo.closeTime, 'HH:mm:ss')
                        : moment('00:00:00', 'HH:mm:ss'),
                    },
                  ]"
                                    />
                                </div>
                            </a-radio-group>
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="养老机构简介" class="abstract1">
                            <a-textarea
                                    style="width:6.21rem;height: 1.5rem"
                                    placeholder="请输入机构简介"
                                    :rows="6"
                                    v-decorator="[
                'briefIntro',
                {
                  trigger: 'blur',
                  rules: [
                    {
                      required: true,
                      message: '机构简介不能为空'
                    },
                    {
                      validator: this.jianjieCheck.bind(this)
                    }
                  ],
                  initialValue: formData.expansionInfo.briefIntro
                }
              ]"
                            />
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="详细介绍" style="min-height: 4.2rem" class="abstract">
                            <a-input
                                    v-decorator="['detailDescription', { rules:[{ required: true, validator: this.checkDetailInfo.bind(this)}] }]"
                                    style="display: none;"></a-input>
                            <div :style="{'height': `${ editorHeightFun }rem` }" style="width: 6.21rem">
                                <content-editor ref="contentEditor" init-placeholder="请输入养老机构的详细介绍"
                                                @content-callback="HandleGetContentValue"/>
                            </div>
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="备注">
                            <a-textarea
                                    style="width:6.21rem;height: 1.5rem"
                                    :rows="2"
                                    v-decorator="[
                'orgRemark',
                {
                  initialValue: formData.expansionInfo.orgRemark
                }
              ]"
                            />
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="服务信息" class="tip"></a-form-item>
                        <a-form-item :label-col="formTailLayout.labelCol" :wrapper-col="formTailLayout.wrapperCol">
                            <a-checkbox :checked=this.formData.shopInfo.needServiceForOrg @change="radioButton"
                                        v-decorator="['needServiceForOrg',
                                        {
                  initialValue: formData.shopInfo.needServiceForOrg,
                   }]">
                                是否对外提供服务项目
                            </a-checkbox>
                        </a-form-item>
                        <a-form-item v-bind="formItemLayoutTwo" label="服务类目"
                                     v-if="this.formData.shopInfo.needServiceForOrg">
                            <a-input
                                    v-decorator="['serviceCategory', { rules:[{ required: true, validator: this.newDatecs.bind(this)}] }]"
                                    style="display: none"></a-input>
                            <span style="color: #60c7c6; font-size: 0.14rem; cursor: pointer" @click="add"><a-icon type="plus-circle" style="margin-right: 5px"/>新增服务类目</span>
                            <el-table v-if="serviceCategoryList.length!=0" :data="serviceCategoryList"
                                      :span-method="objectSpanMethod"
                                      border>
                                <el-table-column prop="categoryOneName" label="一级服务类目" align="center"></el-table-column>
                                <el-table-column prop="categoryTwoName" label="二级服务类目" align="center"></el-table-column>
                                <el-table-column label="操作" align="center">
                                    <template slot-scope="scope">
                                        <div class="remove" @click="delServiceInfo(scope.row)">删除
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="管理员信息" class="tip"></a-form-item>
                        <a-form-item v-bind="formItemLayout" label="管理员姓名">
                            <a-input
                                    placeholder="请输入管理员姓名"
                                    v-decorator="[
                'adminName',
                {
                  rules: [
                    {
                      required: true,
                      message: '管理员姓名不能为空'
                    }
                  ],
                  initialValue: formData.administratorInfo.adminName
                }
              ]"
                            />
                            <p class="fileTipBox202005062" style="top: 0.31rem">
                                请确保管理员信息准确，后续结算账户修改及支付密码等重要信息设置均需管理员验证</p>
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="管理员身份证号" style="margin-top: 0.33rem">
                            <a-input
                                    placeholder="请输入管理员身份证号"
                                    v-decorator="[
                'admininfoCard',
                {
                  rules: [
                    {
                      required: true,
                      validator: this.infoCardCheck.bind(this)
                    }
                  ],
                  initialValue: formData.administratorInfo.adminIdNum
                }
              ]"
                            />
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="管理员联系手机">
                            <a-input
                                    placeholder="请输入管理员联系手机"
                                    v-decorator="[
                'adminTel',
                {
                  rules: [
                    {
                      required: true,
                      validator: this.telCheck.bind(this)
                    }
                  ],
                  initialValue: formData.administratorInfo.adminTel
                }
              ]"
                            />
                            <div class="authCode">
                                <a-button
                                        v-if="!isSending"
                                        @click="handleSendCode"
                                        style="font-size:0.16rem"
                                >{{ isSendingFisrt ? "点击获取验证码" : "重新获取" }}
                                </a-button
                                >
                                <a-button v-else style="font-size:0.16rem">{{
                                    `${remainTime}s后重新获取`
                                    }}
                                </a-button>

                            </div>
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="验证码">
                            <a-input
                                    placeholder="请输入验证码"
                                    v-decorator="[
                'yzm',
                {
                  rules: [
                    {
                      required: true,
                      validator: this.yzmCheck.bind(this)
                    }
                  ]
                }
              ]"
                            />

                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="机构特色" class="tip"></a-form-item>
                        <a-form-item v-bind="formItemLayout1" label="" id="djaksdniodljnak">
                            <a-checkbox-group
                                    v-decorator="[
                'fwts',
                {
                  rules: [],
                  initialValue: initialValue.fwts,
                },
              ]"
                            >
                                <div class="feature">
                                    <div v-for="(item,index) in serviceList" :key="item.key" class="tdajosnBox">
                                        <a-checkbox :value="item.key">
                                            <span class="span1" :title="item.value">{{ item.value }}</span>
                                            <span class="span2">{{ item.desc }}</span>
                                        </a-checkbox>
                                    </div>
                                </div>

                            </a-checkbox-group>
                        </a-form-item>
                        <a-form-item v-bind="tailFormItemLayout" class="present">
                            <a-button class="button1" html-type="submit" @click="back()"><img
                                    src="../../assets/images/homeImg/路径 2330@2x.png"/>返回上一步
                            </a-button>
                            <a-button class="button2" v-if="buttonSet.enableClick" :loading="buttonSet.loading"
                                      type="primary" @click="handleSubmit"><img
                                    src="../../assets/images/homeImg/yes.png"/>提交审核
                            </a-button>
                            <a-button class="button2" v-else :loading="buttonSet.loading" type="primary" disabled><img
                                    src="../../assets/images/homeImg/yes.png"/>提交审核
                            </a-button>
                        </a-form-item>
                    </div>
                </a-form>
            </div>
        </div>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel" :width="'30vw'">
            <div style="margin-top: 0.2rem;">
                <img alt="example" style="width: 100%;max-height: 5rem;margin-bottom: 0.3rem" :src="previewImage"/>
            </div>
        </a-modal>

        <a-modal :visible="serviceCategoryModel" @cancel="handleCancel" width="6.3rem">
            <template slot="title">
                <div class="modal-header">
                    <span>新增养老机构类目</span>
                </div>
            </template>
            <div class="erviceCategoryStyle">
                <el-cascader-panel v-model="serviceData" :options="serviceTypes" clearable :props="{ multiple: true}"
                                   @change="value => cascaderChange(value)">
                    <template slot-scope="{ node, data }">
                        <span>{{ data.label }}</span>
                        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                    </template>
                </el-cascader-panel>
            </div>
            <template slot="footer">
                <div class="modal-footer">
                    <div class="ok-button" @click="erviceCategoryDate">
                        <span><img src="../../assets/images/homeImg/yes.png"/>确认</span>
                    </div>
                    <div class="cancel-button" @click="handleCancel">
                        <span><img src="../../assets/images/homeImg/no.png"/>取消</span>
                    </div>
                </div>
            </template>
        </a-modal>
        <a-modal width="6.6rem" v-model="visibleConfirm" @ok="handleClickConfirm"
                 :afterClose="handleClickConfirm">
            <template slot="title">
                <div class="modal-header">
                    <span>入驻信息</span>
                </div>
            </template>
            <Confirm/>
            <template slot="footer">
                <div class="modal-footer">
                    <div class="ok-button" @click="handleClickConfirm">
                        <span><img src="../../assets/images/homeImg/yes.png"/>确认</span>
                    </div>
                </div>
            </template>
        </a-modal>
        <Footer/>
    </div>
</template>

<script>
    import Vue from "vue";
    import Nav from "@/components/Nav";
    import Footer from "@/components/Footer";
    import Header from "@/components/Header";
    import moment from "moment";
    import MyStepBar from "@/components/enterMyStepBar";
    import {
        Button,
        Cascader,
        Checkbox,
        DatePicker,
        Form,
        Icon,
        Input,
        message,
        Modal,
        Radio,
        Select,
        Upload,
    } from "ant-design-vue";
    import ReturnStep from "@/components/ReturnStep.vue";

    import {
        checkAccountNameExist,
        checkMobileValidateCode,
        checkUserNameExist,
        dictionaries,
        dictionariesWithDesc,
        fetchAddrCascader,
        fetchProvinceName,
        fetchServiceTypes,
        getVerificationCode,
        institutionsIn,
        uploadServiceFile
    } from "@/services/api";

    import Confirm from "./OrganizationJoinStep3";
    import {baseUrl} from "@/services/http";
    import ElementUI from 'element-ui';
    import ContentEditor from "@/views/Join/util/content-editor";

    Vue.use(ElementUI);
    Vue.use(Button);
    Vue.use(Form);
    Vue.use(Input);
    Vue.use(Select);
    Vue.use(Upload);
    Vue.use(Icon);
    Vue.use(DatePicker);
    Vue.use(Cascader);
    Vue.use(Radio);
    Vue.use(Checkbox);
    Vue.use(Modal);

    export default {
        components: {
            Nav,
            Footer,
            Header,
            ReturnStep,
            Confirm,
            ContentEditor,
            MyStepBar
        },
        data() {
            let heightCoefficient = window.innerHeight / 1080,
                // F(x) = -0.24200379107195477*x*x+4.46424066884904*x-0.20860334347523352
                editorHeightFun = heightCoefficient * heightCoefficient * (-0.24200379107195477) + 4.46424066884904 * heightCoefficient - 0.20860334347523352
            return {
                cheYZMBynet: false,
                editorHeightFun: editorHeightFun,
                isSending: false, // 是否发送
                isSendingFisrt: true,
                ifImageCanUpload: true,
                ifImageCanUploadTwo: true,
                uploadCoverFileList: [],
                uploadAtlasList: [],
                showRepeat: false,
                previewVisible: false,
                imageUrl: [],
                previewImage: '',
                formTailLayout :{
                    labelCol: { span: 4 },
                    wrapperCol: { span: 8, offset: 10},
                },
                formItemLayoutTwo: {
                    labelCol: {
                        xs: {span: 24},
                        sm: {span: 10},
                    },
                    wrapperCol: {
                        xs: {span: 24},
                        sm: {span: 9},
                    },
                },
                formItemLayout: {
                    labelCol: {
                        xs: {span: 24,},
                        sm: {span: 10,},
                    },
                    wrapperCol: {
                        xs: {span: 24,},
                        sm: {span: 14,},
                    },
                },
                formItemLayoutThree: {
                    labelCol: {
                        xs: {span: 24,},
                        sm: {span: 16,},

                    },
                    wrapperCol: {
                        xs: {span: 24,},
                        sm: {span: 8,},
                    },
                },
                formItemLayout1: {

                    wrapperCol: {
                        xs: {offset: 9,},
                        sm: {offset: 9,},
                    },
                },
                tailFormItemLayout: {
                    wrapperCol: {
                        xs: {
                            span: 24,
                            offset: 0,
                        },
                        sm: {
                            span: 13,
                            offset: 10,
                        },
                    },
                },
                stepData: [
                    {
                        name: "入驻协议",
                        time: "",
                        img: require('@/assets/images/homeImg/enter-1.png'),
                    },
                    {
                        name: "主体信息",
                        time: "",
                        img: require('@/assets/images/homeImg/enter-2.png'),
                    },
                    {
                        name: "养老机构信息",
                        time: "",
                        img: require('@/assets/images/homeImg/enter-3.png'),
                    },
                ],
                list: [1],
                serviceType: [], // 服务形式
                orgType: [], // 机构类别
                fnreType: [], // 养老机构性质
                plainOptions: [], // 机构收住对象
                selectCategory: [],
                options: [], // 地址选择器
                serviceTypes: [], // 机构类目
                serviceTypesPathMap: [], // 机构类目
                serviceList: [],
                atlasInstitutions: [],//机构图集存储当前图片的路径
                formData: {
                    organizationInfo: {
                        // 公司信息
                        companyName: "", // 公司名称
                        orgCode: "", // 公司组织机构代码
                        companyAddressDetail: "", // 公司详细地址
                        companyContactNumber: "", // 公司电话
                        companyProvince: "", // 公司地址（省、直辖市、自治区等）
                        companyCity: "", // 公司地址（市）
                        companyArea: "", // 公司地址（区、县）
                        companyStreet: "", // 公司地址（街道、乡）
                        detailDescription: "",
                    },
                    accountInfo: {
                        // 联系人及账户信息
                        lpName: "", // 法人名称
                        lpIdNum: "", // 法人身份证编号
                        lpTel: "", // 法人联系方式
                        accountName: "", // 银行开户名
                        accountNumber: "", // 银行开户账号
                        bankName: "", // 开户银行名称
                        accountDetailAdd: "", // 开户详细地址
                        businessLicensePicture: "", // 营业执照照片
                        accountProvince: "",  //开会所在省
                        accountCity: "",  //开户所在市
                        accountArea: "", //开户所在县区
                        accountStreet: "", //开户所在街道
                        lpIdPicturePositive: "", // 法人身份证照片正面
                        lpIdPictureNegative: "", // 法人身份证照片反面
                        emergencyContactName: "", // 紧急联系人姓名
                        emergencyContactPhone: "", // 紧急联系人-联系方式
                        accountOpeningPermit: "",
                        operatingLicense: "",
                        productQualificationCertificate: "",
                    },
                    administratorInfo: {
                        // 管理员信息
                        adminName: "", // 管理员姓名
                        adminIdNum: "", // 管理员身份证编号
                        adminTel: "" // 管理员手机号
                    },
                    expansionInfo: {
                        coverImage: "",
                        createTime: "",
                        briefIntro: "",
                        orgRemark: "",
                        areaSize: 0,
                        orgIntro: "",
                    },
                    shopInfo: {
                        orgAccount: JSON.parse(localStorage.getItem("userInfo"))["userName"], // 商家账号
                        orgName: "",
                        orgForm: [],
                        servicesCategoryList: [],
                        orgImagesList: [],
                        orgType: "",
                        orgCharacter: "",
                        serviceOdject: "",
                        addressProvince: "",
                        needServiceForOrg: false,
                        addressCity: "",
                        addressArea: "",
                        addressStreet: "",
                        addressDetail: "",
                        bedNum: "",
                        lowestPrice: "",
                        highestPrice: "",
                        orgTel: "",
                        openTime: "",
                        closeTime: "",
                        shopAddress: [],
                    },
                    label: {
                        specialService: [],
                    },
                },
                needSetBusinessTime: false,
                buttonSet: {
                    loading: false,
                    enableClick: false,
                },
                remainTime: 60,
                addrPlaceHolder: "请选择机构所在地",
                initialValue: {
                    // 需要进行初始化处理的数据
                    refcev: [], // 收住对象
                    serviceOrNot: '',
                    orgForm: [], // 养老形式
                    ndewi: [], // 机构类别
                    fnre: "", // 养老机构性质
                    serviceTypes: [], // 机构类目
                    fwts: [], // 服务特色
                    orgImagesList: [] //上传图集
                },
                visibleConfirm: false,
                selectedData: [],
                serviceCategoryList: [],
                serviceData: [],
                serviceCategoryModel: false,

            };
        },
        beforeCreate() {
            const userInfo = localStorage.getItem("userInfo");
            if (userInfo) {
                this.form = this.$form.createForm(this);
            } else {
                this.$router.push("/login");
            }
        },
        mounted() {
            let initRefr = {};
            this.init();
            this.visibleConfirm = false;
            dictionaries([65, 67, 69, 74]).then((res) => {
                if (res && res.code == 0) {
                    this.serviceType = res.values[74];
                    this.orgType = res.values[65];
                    this.fnreType = res.values[67];
                    this.plainOptions = res.values[69].map((i) => {
                        return {
                            label: i.value,
                            value: i.key.toString(),
                        };
                    });
                } else {
                    message.error("获取机构类别失败");
                }
            }).then(() => {
                dictionariesWithDesc(70).then((res) => {
                    if (res && res.code == 0) {
                        this.serviceList = res.values;
                    } else {
                        message.error(res.msg);
                    }
                });
            }).then(() => {
                // 获取服务类目
                fetchServiceTypes()
                    .then((res) => {
                        if (res && res.code == 0) {
                            this.serviceTypes = res.data.list;
                        } else {
                            message.error(res.msg);
                        }
                    })
                    .then((_) => {
                        // 返回上一步的时候数据给他填回去
                        let item = localStorage.getItem("organizationJoinForm");
                        if (item == null) {
                            message.error("前置信息获取失败，请重新填写");
                            this.$router.back();
                            return;
                        }
                        if (item) {
                            let data = JSON.parse(item);
                            this.formData = data;
                            if (data.shopInfo.orgAccount == "") {
                                this.formData.shopInfo.orgAccount = JSON.parse(localStorage.getItem("userInfo"))["userName"]
                            }
                            // 养老形式
                            if (this.formData.shopInfo.orgForm) {
                                if (typeof data.shopInfo.orgForm == "string") {
                                    this.formData.shopInfo.orgForm = data.shopInfo.orgForm.split(",");
                                    this.formData.shopInfo.orgForm.forEach((i) => this.initialValue.orgForm.push(parseInt(i)));
                                } else {
                                    this.formData.shopInfo.orgForm = data.shopInfo.orgForm;
                                    this.formData.shopInfo.orgForm.forEach((i) => this.initialValue.orgForm.push(parseInt(i)));
                                }
                            }
                            //封面图片
                            if (this.formData.expansionInfo.coverImage) {
                                this.uploadCoverFileList.push({
                                    uid: "coverImage",
                                    name: "coverImage.png",
                                    status: "done",
                                    url: this.formData.expansionInfo.coverImage.indexOf("/fileupload") == 0 ? `${baseUrl}${this.formData.expansionInfo.coverImage}` : this.formData.expansionInfo.coverImage,
                                });
                            }
                            //图集
                            this.formData.shopInfo.orgImagesList.forEach((item, index) => {
                                if (this.formData.shopInfo.orgImagesList) {
                                    //图片数据赋值出来
                                    this.atlasInstitutions.push({
                                        "uid": "imageUrl" + index,
                                        "path": item
                                    })
                                    this.uploadAtlasList.push({
                                        uid: "imageUrl" + index,
                                        name: "imageUrl" + index + ".png",
                                        status: "done",
                                        url: item.indexOf("/fileupload") == 0 ? `${baseUrl}${item}` : item,
                                    });
                                }
                            })

                            // 机构类别
                            if (this.formData.shopInfo.orgType) {
                                let orgInt;
                                if ((orgInt = parseInt(this.formData.shopInfo.orgType)))
                                    this.initialValue.ndewi = parseInt(this.formData.shopInfo.orgType);
                            }
                            //地址回填
                            // this.initAllArea([
                            //   this.formData.shopInfo.addressProvince,
                            //   this.formData.shopInfo.addressCity,
                            //   this.formData.shopInfo.addressArea
                            // ]);
                            // 养老机构性质
                            if (this.formData.shopInfo.orgCharacter) {
                                this.initialValue.fnre = parseInt(this.formData.shopInfo.orgCharacter);
                            }
                            //是否对外提供服务项目
                            if (this.formData.shopInfo.needServiceForOrg) {
                                this.formData.shopInfo.needServiceForOrg = data.shopInfo.needServiceForOrg;
                            }

                            // 收住对象
                            if (this.formData.shopInfo.serviceOdject) {
                                if (typeof data.shopInfo.serviceOdject == "string") {
                                    this.formData.shopInfo.serviceOdject = data.shopInfo.serviceOdject.split(
                                        ","
                                    );
                                    this.initialValue.refcev = this.formData.shopInfo.serviceOdject;
                                } else {
                                    this.formData.shopInfo.serviceOdject =
                                        data.shopInfo.serviceOdject;
                                    this.initialValue.refcev = this.formData.shopInfo.serviceOdject;
                                }
                            }

                            // 机构特色
                            if (this.formData.label.specialService) {
                                if (typeof data.label.specialService == "string") {
                                    this.formData.label.specialService = data.label.specialService.split(",");
                                    this.formData.label.specialService.forEach((i) => this.initialValue.fwts.push(parseInt(i)));
                                } else {
                                    this.formData.label.specialService = data.label.specialService;
                                    this.formData.label.specialService.forEach((i) => this.initialValue.fwts.push(parseInt(i))
                                    );
                                }
                            }

                            // 机构类目
                            if (data.shopInfo.servicesCategoryList.length != 0) {
                                var dataNumber = [];
                                var dataNumber2 = [];
                                const list = data.shopInfo.servicesCategoryList
                                list.forEach(item => {
                                    this.serviceTypes.forEach(item2 => {
                                        item2.children.forEach(item3 => {
                                            if (item === item3.value) {
                                                dataNumber.push({
                                                    categoryId: item3.value,
                                                    categoryOneName: item2.label,
                                                    categoryTwoName: item3.label
                                                })
                                                dataNumber2.push([item2.value, item3.value])
                                            }
                                        })
                                    })
                                })
                                this.serviceData = dataNumber2
                                this.sort_pro(dataNumber)

                            }

                            // 时间
                            if (this.formData.shopInfo.openTime && this.formData.shopInfo.closeTime) {
                                if (this.formData.shopInfo.openTime == "00:00:00" && this.formData.shopInfo.closeTime == "00:00:00"
                                ) {
                                    this.needSetBusinessTime = false;
                                } else {
                                    this.needSetBusinessTime = true;
                                }
                                initRefr["businessHours"] = this.needSetBusinessTime;
                            }
                            //获取地址回填信息
                            if (data.shopInfo.addressProvince != '') {
                                var companyProvince = Number(data.shopInfo.addressProvince);
                                var companyCity = Number(data.shopInfo.addressCity);
                                var companyArea = Number(data.shopInfo.addressArea);
                                var companyStreet = Number(data.shopInfo.addressStreet);
                                this.formData.shopInfo.shopAddress = [companyProvince, companyCity, companyArea, companyStreet];
                                let m = JSON.parse(JSON.stringify(this.formData.shopInfo.shopAddress));
                                m.pop();
                                this.initAllArea(m);
                            }
                            if (data.shopInfo.lowestPrice != '' && data.shopInfo.highestPrice != '') {
                                var reg = /.*\..*/;
                                var lowestPrice = reg.test(data.shopInfo.lowestPrice);
                                var highestPrice = reg.test(data.shopInfo.highestPrice)
                                if (lowestPrice != true && highestPrice != true) {
                                    this.formData.shopInfo.lowestPrice = data.shopInfo.lowestPrice.toFixed(2)
                                    this.formData.shopInfo.highestPrice = data.shopInfo.highestPrice.toFixed(2)
                                }
                            }

                            // 详细信息回填
                            this.$refs['contentEditor'].init(data.organizationInfo.detailDescription)

                        } else {
                            message.error("前置信息获取失败，请重新填写");
                            this.$router.back();
                        }


                        this.buttonSet.loading = false;
                        this.buttonSet.enableClick = true;
                    })
                    .then((_) => {
                        this.form.setFieldsValue(initRefr);
                    });
            });
        },
        methods: {
            // //监听是否对外提供服务
            radioButton(e) {
                this.formData.shopInfo.needServiceForOrg = e.target.checked;

                if (this.formData.shopInfo.needServiceForOrg) {
                    this.formData.shopInfo.servicesCategoryList = [];
                    this.list = [1];
                }
            },
            //自定义上传封面
            uploadCoverAll(options) {
                let t = setTimeout(() => {
                    clearTimeout(t);
                    this.uploadCover(options);
                }, 1000);
            },

            // 上传封面
            uploadCover(options) {
                if (!this.ifImageCanUpload) return;
                let formData = new FormData();
                formData.append("file", options.file);
                formData.append("typeId", 3);
                let p = {
                    percent: 0
                };
                uploadServiceFile(formData, ({total, loaded}) => {
                    p.percent = +Math.round((loaded / total) * 100).toFixed(2);
                    options.onProgress(p);
                    if (p.percent >= 100) {
                        options.onProgress({percent: 99.3});
                    }
                }).then(data => {
                    if (data && data.code == 0) {
                        // message.success("上传成功");
                        options.onSuccess();
                        this.formData.expansionInfo.coverImage = data.filePath;
                        this.uploadCoverFileList.push({
                            uid: "coverImage",
                            name: "coverImage.png",
                            status: "done",
                            url: this.formData.expansionInfo.coverImage.indexOf("/fileupload") == 0 ? `${baseUrl}${data.filePath}` : data.filePath,
                        });
                    } else {
                        message.error(data.msg);
                        this.uploadCoverFileList.pop();
                    }
                })
                    .catch(error => {
                        message.error("上传失败");
                        this.uploadCoverFileList.pop();
                        this.form.validateFields(["coverImage"], errors => {
                        });
                    });
            },
            // 移除封面
            uploadCoverRemove(file) {
                this.uploadCoverFileList = [];
                this.formData.expansionInfo.coverImage = "";
            },

            //自定义上传图集
            uploadAtlasAll(options) {
                let t = setTimeout(() => {
                    clearTimeout(t);
                    this.uploadAtlas(options);
                }, 1000);
            },
            //上传图集
            uploadAtlas(options) {
                if (!this.ifImageCanUploadTwo) return;
                let formData = new FormData();
                formData.append("file", options.file);
                formData.append("typeId", 3);
                let p = {
                    percent: 0
                };
                uploadServiceFile(formData, ({total, loaded}) => {
                    p.percent = +Math.round((loaded / total) * 100).toFixed(2);
                    options.onProgress(p);
                    if (p.percent >= 100) {
                        options.onProgress({percent: 99.3});
                    }
                }).then(data => {

                    if (data && data.code == 0) {
                        options.onSuccess();
                        //获取上传数据
                        const file = options.file;
                        this.atlasInstitutions.push({
                            "uid": file.uid,
                            "path": data.filePath,
                        })
                        this.uploadAtlasList.push({
                            uid: "imageUrl" + file.uid,
                            name: "imageUrl" + file.uid + ".png",
                            status: "done",
                            url: `${baseUrl}${data.filePath}`,
                        });
                    } else {
                        message.error(data.msg);
                        this.uploadAtlasList.pop();
                    }
                }).catch(error => {
                    message.error("上传失败");
                    this.uploadAtlasList.pop();
                });
            },
            //移除图集
            uploadAtlasRemove(file) {
                this.uploadAtlasList = [];
                this.formData.shopInfo.orgImagesList = [];
            },

            //校验图片上传
            uploadCoverFileCheck(rule, value, callback) {
                if (this.formData.expansionInfo.coverImage) {
                    callback();
                    return;
                }
                if (!value || value.fileList.length == 0) {
                    callback("请上传封面图片");
                    return;
                }
                if (value.file.size > 3000 * 1000 * 1) {
                    this.ifImageCanUpload = false;
                    value.fileList.length = 0;
                    this.form.setFieldsValue({coverImage: ""});
                    message.error("上传失败，请控制图片在3M之内");
                    callback();
                    return;
                } else {
                    this.ifImageCanUpload = true;
                    callback();
                }
            },
            //校验图集上传
            uploadCoverFileCheckOne(rule, value, callback) {
                if (this.formData.shopInfo.orgImagesList) {
                    callback();
                    return;
                }
                if (value.file.size > 3000 * 1000 * 1) {
                    this.ifImageCanUploadTwo = false;
                    value.fileList.length = 0;
                    this.form.setFieldsValue({coverImage: ""});
                    message.error("上传失败，请控制图片在3M之内");
                    callback();
                    return;
                } else {
                    this.ifImageCanUploadTwo = true;
                    callback();
                }
            },
            // 图片预览
            async handlePicturePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await this.getBase64(file.originFileObj);
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },
            // 将文件转成Base64
            getBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
            },
            /* 预览框关闭*/
            handleCancel() {
                this.previewVisible = false;
                this.serviceCategoryModel = false;
            },

            /* 校验公司简介*/
            jianjieCheck(rule, value, callback) {
                if (value && value.length <= 9) {
                    callback("公司简介最少10个字（包含10个）");
                    return;
                }
                callback();
            },
            //占地面积
            numberkeyup(e) {
                const a = +e.target.value;
                //
                if (a) this.form.setFieldsValue({areaSize: a < 0 ? null : a});
            },
            /*校验身份证号*/
            infoCardCheck(rule, value, callback) {
                const field = rule.field;
                const fieldsObject = {
                    admininfoCard: "管理员"
                };
                if (!value) {
                    callback(`${fieldsObject[field]}身份证号不能为空`);
                    return;
                }

                // ^\d{15}|\d{18}$
                const reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
                if (!reg.test(value)) {
                    callback("格式不正确，请输入正确格式的身份证号");
                    return;
                }
                callback();
            },
            /*校验手机号*/
            telCheck(rule, value, callback) {
                const field = rule.field;
                const fieldsObject = {
                    adminTel: "管理员联系手机"
                };
                if (!value) {
                    callback(`${fieldsObject[field]}不能为空`);
                    return;
                }

                const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
                if (!reg.test(value)) {
                    callback("格式不正确，请输入正确格式的手机号");
                    return;
                }
                callback();
            },
            //验证码
            yzmCheck(rule, value, callback) {
                if (!value) {
                    callback("请填写验证码");
                    return;
                }
                if (!this.cheYZMBynet) {
                    return;
                }

                let getFormValue = name => this.form.getFieldValue(name);

                if (this.t) {
                    clearTimeout(this.t);
                }
                this.t = setTimeout(() => {
                    checkMobileValidateCode({
                        mobile: getFormValue("adminTel"),
                        code: getFormValue("yzm")
                    }).then(res => {
                        if (res && res.code == 0) {
                            callback();
                        } else {
                            callback("短信验证码错误或已失效，请重新获取");
                        }
                    });
                }, 100);
            },
            /*发送验证码*/
            handleSendCode() {
                let mobile = this.form.getFieldValue("adminTel");
                this.form.validateFields(["adminTel"], (errors, values) => {
                    if (!errors) {
                        if (!this.isSending) {
                            this.isSending = true;
                            this.interval = setInterval(() => {
                                if (this.remainTime >= 1) {
                                    this.remainTime -= 1;
                                } else {
                                    this.isSending = false;
                                    window.clearInterval(this.interval);
                                    this.remainTime = 60;
                                }
                            }, 1000);
                            getVerificationCode(mobile).then(res => {
                                this.isSendingFisrt = false;
                                if (res && res.code === 0) {
                                    message.success("验证码已发送！");
                                } else {
                                    message.error(res.msg);
                                }
                            });
                        }
                    } else {
                        return;
                    }
                });
            },
            //手机验证
            phoneCheck(rule, value, callback) {
                if (!value) {
                    callback("机构电话不能为空");
                }
                const reg = /^\d{3}-\d{8}|\d{4}-\d{7}$/;
                const reg2 = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
                if (!reg.test(value) && !reg2.test(value)) {
                    callback("格式不正确，请输入正确格式的公司电话,如：021-87888822,13812345678,0044-1111111");
                } else {
                    callback();
                }
            },
            //返回上一步
            back() {
                this.saveJoinForm();
                this.$router.push("/OrganizationJoinStep1");
            },
            moment,
            getFormValue(name) {
                return this.form.getFieldValue(name);
            },

            //获取数据排序
            sort_pro(data) {
                let group = {}
                let groupId = []
                let endList = []
                data.sort((a, b) => a.categoryTwoName.localeCompare(b.categoryTwoName, 'zh'));
                data.forEach(i => {
                    // group[i.name] = group[i.name] || []
                    if (group[i.categoryOneName]) {
                        group[i.categoryOneName] = group[i.categoryOneName]
                    } else {
                        group[i.categoryOneName] = []
                        groupId.push(i.categoryOneName)
                    }
                    group[i.categoryOneName].push(i)
                })

                groupId.forEach(i => {
                    endList = endList.concat(group[i])
                })
                this.DataPush(endList)
            },

            DataPush(value) {
                this.serviceCategoryList = value
                this.getSpanArr(value);

            },
            // 合并表格数据
            getSpanArr(data) {
                this.spanArr = []
                this.pos = 0
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr.push(1)
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同
                        if (data[i].categoryOneName === data[i - 1].categoryOneName) {
                            this.spanArr[this.pos] += 1
                            this.spanArr.push(0)
                        } else {
                            this.spanArr.push(1)
                            this.pos = i
                        }
                    }
                }
            },
            // 表格合并
            objectSpanMethod({rowIndex, columnIndex}) {
                if (columnIndex === 0) {
                    const _row = this.spanArr[rowIndex]
                    const _col = _row > 0 ? 1 : 0
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                } else {
                    return false
                }
            },

            // 获取富文本框回调
            HandleGetContentValue(content) {
                //转base64，解base64
                this.formData.organizationInfo.detailDescription = Base64.encode(content.toString());
            },
            // 校验详细介绍
            checkDetailInfo(rule, value, callback) {
                if (this.formData.organizationInfo.detailDescription) {
                    callback()
                } else {
                    callback('养老机构的详细介绍不能为空')
                }
            },

            // 新增类目
            add() {
                this.serviceCategoryModel = true;
            },
            //类目选择框变化
            cascaderChange(value) {
                if (value.length === 0) {
                    this.selectedData = this.serviceCategoryList
                } else {
                    this.selectedData = value
                }
            },
            //服务类目为空判断
            newDatecs(rule, value, callback) {
                if (this.serviceCategoryList.length === 0) {
                    callback("服务类目不能为空，请选择。");
                    return
                }
                callback();
            },
            //确认新增类目
            erviceCategoryDate() {
                var dataNumber = [];
                var dataNumber2 = [];
                if (this.selectedData.length === 0) {
                    this.serviceCategoryList.forEach(item => {
                        this.serviceTypes.forEach(item2 => {
                            item2.children.forEach(item3 => {
                                if (item.categoryId === item3.value) {
                                    dataNumber.push({
                                        categoryId: item3.value,
                                        categoryOneName: item2.label,
                                        categoryTwoName: item3.label
                                    })
                                    dataNumber2.push([item2.value, item3.value])
                                }
                            })
                        })
                    })
                } else {
                    this.selectedData.forEach(item => {
                        this.serviceTypes.forEach(item2 => {
                            item2.children.forEach(item3 => {
                                if (item[1] === item3.value) {
                                    dataNumber.push({
                                        categoryId: item3.value,
                                        categoryOneName: item2.label,
                                        categoryTwoName: item3.label
                                    })
                                    dataNumber2.push([item2.value, item3.value])
                                }
                            })
                        })
                    })
                }
                this.sort_pro(dataNumber);
                this.serviceData = dataNumber2
                this.serviceCategoryModel = false

                this.form.setFieldsValue({
                    serviceCategory: 0
                })
                this.form.validateFields(['serviceCategory'], (err) => {
                })
            },
            //删除类目
            delServiceInfo(row) {
                const dataNumber22 = [];
                const dataNumber33 = [];
                this.serviceCategoryList.splice(this.serviceCategoryList.indexOf(row), 1)
                this.serviceCategoryList.forEach(item => {
                    this.serviceTypes.forEach(item2 => {
                        item2.children.forEach(item3 => {
                            if (item.categoryId === item3.value) {
                                dataNumber33.push({
                                    categoryId: item3.value,
                                    categoryOneName: item2.label,
                                    categoryTwoName: item3.label
                                })
                                dataNumber22.push([item2.value, item3.value])
                            }
                        })
                    })
                })
                this.sort_pro(dataNumber33);
                this.serviceData = dataNumber22
                if (this.serviceData.length === 0) {
                    this.form.setFieldsValue({
                        serviceCategory: 0
                    })
                    this.form.validateFields(['serviceCategory'], (err) => {
                    })
                }
            },

            //验证码提交
            tdajosnBoxClick(id) {
                const fwts = this.getFormValue("fwts");
                return fwts.includes(id);
            },
            // 提交
            handleSubmit(e) {
                e.preventDefault();
                if (this.buttonSet.enableClick) {
                    this.buttonSet.loading = true;
                    this.buttonSet.enableClick = true;
                    this.cheYZMBynet = true;
                    this.form.validateFieldsAndScroll(
                        null,
                        {
                            first: false,
                            scroll: {
                                offsetTop: 120,
                            },
                        },

                        (err, values) => {
                            this.cheYZMBynet = false
                            if (!err) {
                                this.saveJoinForm();
                                institutionsIn(this.formData).then((res) => {
                                    this.buttonSet.loading = false;
                                    this.buttonSet.enableClick = true;

                                    if (res && res.code == 0) {
                                        // message.success("提交成功，等待审核");

                                        this.buttonSet.loading = false;
                                        this.buttonSet.enableClick = true;
                                        this.visibleConfirm = true;
                                        localStorage.removeItem("organizationJoinForm");

                                    } else {
                                        this.buttonSet.loading = false;
                                        this.buttonSet.enableClick = true;
                                        message.error(res.msg);
                                    }
                                });
                            } else {
                                this.buttonSet.loading = false;
                                this.buttonSet.enableClick = true;
                            }
                        }
                    );

                }
            },
            //获取地址信息并回填
            async initAllArea([a, b, c]) {
                let opton = this.options;
                for (let level of [a, b, c]) {
                    let item = opton.find((item) => item.value == level);
                    await this.loadData([item]);
                    opton = item.children;
                }
            },
            // 初始化地址
            init(place) {
                return new Promise((resolve) => {
                    fetchAddrCascader({
                        areaType: 0,
                        areaId: "",
                    }).then((data) => {
                        resolve();
                        if (data && data.code == 0) {
                            const list = data.data.list;
                            let children = [];
                            if (list) {
                                list.forEach((i) => {
                                    children.push({
                                        label: i.name,
                                        value: i.id,
                                        level: 1,
                                        isLeaf: false,
                                    });
                                });
                            }
                            this.options = children;
                        } else {
                            message.error(data.msg);
                        }
                    });
                });
            },
            // 获取地址信息
            loadData(selectedOptions) {
                if (selectedOptions[0] != undefined) {
                    const targetOption = selectedOptions[selectedOptions.length - 1];
                    const {value} = targetOption;
                    const {level} = targetOption;
                    targetOption.loading = true;

                    return new Promise((resolve) => {
                        fetchAddrCascader({
                            areaType: level,
                            areaId: value,
                        }).then((data) => {
                            resolve();
                            targetOption.loading = false;
                            if (data && data.code == 0) {
                                const list = data.data.list;
                                let children = [];
                                if (list) {
                                    list.forEach((i) => {
                                        children.push({
                                            label: i.name,
                                            value: i.id,
                                            isLeaf: i.childNum == 0,
                                            level: level + 1,
                                        });
                                    });
                                }
                                targetOption.loading = false;
                                targetOption.children = children;
                                this.options = [...this.options];
                            } else {
                                message.error(data.msg);
                            }
                        });
                    });
                }

            },
            // 校验最高价格比最低价格要多
            maxThanMin(rule, value, callback) {
                if (!value) {
                    callback("机构最高价格不能为空");
                    return;
                }
                if (+value <= 0) {
                    callback("金额格式不正确,价格不能为0和负数");
                    return;
                }
                let lowestPrice = parseInt(this.getFormValue("lowestPrice"));
                if (lowestPrice >= 0) {
                    if (parseInt(value) < lowestPrice) {
                        callback("最高价格不能比最低价格低");
                        return;
                    }
                }

                this.form.setFieldsValue({highestPrice: (+value).toFixed(2)});
                callback();
            },
            //验证最低价格
            formater(rule, value, callback) {
                if (!value) {
                    callback("机构最低价格不能为空");
                    return;
                }
                if (+value <= 0) {
                    callback("金额格式不正确,价格不能为0和负数");
                    return;
                }
                this.form.setFieldsValue({lowestPrice: (+value).toFixed(2)});

                callback();
            },
            // 检查商家账号是否已存在
            checkExist(rule, value, callback) {
                // 校验机构的名称是否被占用
                if (value) {
                    // 不能全是数字或者以数字开头
                    if (/^[0-9]*$/.test(value)) {
                        callback(new Error("用户名不能为纯数字，请重新输入"));
                        return;
                    }

                    checkUserNameExist(value)
                        .then((res) => {
                            if (res && res.code == 0) {
                                callback();
                            } else {
                                callback(res.msg);
                            }
                        })
                        .catch((e) => {
                            callback(e);
                        });
                } else {
                    callback(new Error("请填写养老机构账号！"));
                }
            },
            // 检查商家名称是否已存在
            checkExistName(rule, value, callback) {
                // 校验机构的名称是否被占用
                if (value) {
                    checkAccountNameExist(value)
                        .then((res) => {
                            if (res && res.code == 0) {
                                callback();
                            } else {
                                callback(res.msg);
                            }
                        })
                        .catch((e) => {
                            callback(e);
                        });
                } else {
                    callback(new Error("机构名称不能为空"));
                }
            },
            // 校验营业时间
            checkBusinessTime(rule, value, callback) {
                const that = this;
                if (value) {
                    // 是否是自定义
                    let openTime = that.getFormValue("opentime");
                    let closeTime = that.getFormValue("closetime");
                    if (!openTime) {
                        callback(new Error("请设置开始营业时间"));
                    }
                    if (!closeTime) {
                        callback(new Error("请设置营业结束时间"));
                    }
                    if(openTime>closeTime){
                        callback(new Error("开始时间要早于结束时间"));
                    }
                }
                callback();
            },
            // 选择经营时间
            onBusinessHoursChange(e) {
                this.needSetBusinessTime = e.target.value;
            },
            //自定义营业时间判断(开始时间)
            startTime(e){
            },
            //自定义营业时间判断(结束时间)
            endTime(e){
            },

            /*选择机构地址*/
            selectAddress(value, selectedOptions) {
                if (value.length >= 3 && value.length <= 4) {
                    this.formData.shopInfo.addressProvince = value[0];
                    this.formData.shopInfo.addressCity = value[1];
                    this.formData.shopInfo.addressArea = value[2];
                    this.formData.shopInfo.addressStreet = value[3] || "";
                    this.formData.shopInfo.shopAddress = value;
                    fetchProvinceName({
                        province: this.formData.shopInfo.addressProvince,
                        city: this.formData.shopInfo.addressCity,
                        area: this.formData.shopInfo.addressArea,
                        street: this.formData.shopInfo.addressStreet
                    }).then(res => {
                        if (res.code == 0) {
                            const add = res.info.addr;
                            this.formData.shopInfo.shopAddress = `${add.province}/${add.city}/${add.area}${add.street ? `/${add.street}` : ""}`;
                        } else {
                            message.error(res.msg);
                        }
                    });
                }
            },
            /**校验机构地址*/
            addrcheck(rule, value, callback) {
                if (!this.formData.shopInfo.shopAddress || this.formData.shopInfo.shopAddress.length == 0) {
                    callback(new Error("机构所在地不能为空"));
                } else {
                    callback();
                }
            },
            ndewichange(value) {
            },
            /*确认*/
            handleClickConfirm(e) {
                this.$router.push("/OrganizationJoinProcess");
            },
            // 存储数
            saveJoinForm() {

                // 机构类目去重
                this.formData.shopInfo.servicesCategoryList = [];
                for (let key in this.selectCategory) {
                    let category = this.selectCategory[key];
                    if (this.formData.shopInfo.servicesCategoryList.indexOf(category) == -1) {
                        this.formData.shopInfo.servicesCategoryList.push(category);
                    }
                }
                // 机构类目填充
                this.formData.shopInfo.servicesCategoryList = [];
                var serviceCategoryType = []
                this.serviceCategoryList.forEach((i) => {
                    if (i != '') {
                        this.formData.shopInfo.servicesCategoryList.push(i.categoryId);
                    }
                });

                this.formData.shopInfo.orgAccount = this.getFormValue("orgAccount");
                this.formData.shopInfo.orgName = this.getFormValue("orgName");
                this.formData.shopInfo.orgForm = this.getFormValue("orgForm");
                let orgType = this.getFormValue("ndewi");
                if (orgType) {
                    this.formData.shopInfo.orgType = orgType;
                } else {
                    this.formData.shopInfo.orgType = "";
                }
                this.formData.shopInfo.orgCharacter = this.getFormValue("fnre");
                this.formData.shopInfo.serviceOdject = this.getFormValue("refcev");
                this.formData.shopInfo.addressDetail = this.getFormValue("addressDetail");
                this.formData.shopInfo.bedNum = this.getFormValue("bedNum");
                this.formData.shopInfo.lowestPrice = this.getFormValue("lowestPrice");
                this.formData.shopInfo.highestPrice = this.getFormValue("highestPrice");
                this.formData.shopInfo.orgTel = this.getFormValue("orgTel");
                this.formData.shopInfo.needServiceForOrg = this.getFormValue("needServiceForOrg") == true ? true : false;
                let businessTimeSet = this.getFormValue("businessHours");
                // 填充数据
                this.formData.expansionInfo.createTime = this.getFormValue("createTime");
                this.formData.expansionInfo.areaSize = this.getFormValue("areaSize");
                this.formData.expansionInfo.briefIntro = this.getFormValue("briefIntro");
                this.formData.expansionInfo.orgIntro = this.getFormValue("orgIntro");
                this.formData.expansionInfo.orgRemark = this.getFormValue("orgRemark");
                // 管理员信息填充
                this.formData.administratorInfo.adminName = this.getFormValue("adminName");
                this.formData.administratorInfo.adminIdNum = this.getFormValue("admininfoCard");
                this.formData.administratorInfo.adminTel = this.getFormValue("adminTel");
                this.formData.shopInfo.orgImagesList = this.atlasInstitutions.map(i => i.path);
                if (businessTimeSet) {
                    this.formData.shopInfo.openTime = this.getFormValue("opentime").format("HH:mm:ss");
                    this.formData.shopInfo.closeTime = this.getFormValue("closetime").format("HH:mm:ss");
                } else {
                    this.formData.shopInfo.openTime = "00:00:00";
                    this.formData.shopInfo.closeTime = "00:00:00";
                }

                let fwts = this.getFormValue("fwts");
                if (fwts) {
                    if (fwts.length > 0) {
                        this.formData.label.specialService = fwts.join();
                    } else {
                        // 这个可以没有
                        this.formData.label.specialService = "";
                    }
                }

                if (this.formData.shopInfo.orgForm) {
                    if (
                        Array.isArray(this.formData.shopInfo.orgForm) &&
                        this.formData.shopInfo.orgForm.length > 0
                    ) {
                        this.formData.shopInfo.orgForm = this.formData.shopInfo.orgForm.join();
                    }
                }

                if (this.formData.shopInfo.serviceOdject) {
                    if (
                        Array.isArray(this.formData.shopInfo.serviceOdject) &&
                        this.formData.shopInfo.serviceOdject.length > 0
                    ) {
                        this.formData.shopInfo.serviceOdject = this.formData.shopInfo.serviceOdject.join();
                    }
                }

                localStorage.setItem("organizationJoinForm", JSON.stringify(this.formData));
            },
        },
    };
</script>

<style lang="less">
    .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
        color: #60c7c6 !important;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #60c7c6 !important;
        border-color: #60c7c6 !important;
    }

    //隐藏弹出框最外边框
    .el-cascader-panel.is-bordered {
        border: none !important;
    }

    //设置类目弹出框框中样式（下三个）
    .el-cascader-menu {
        height: 1.8rem;
        border: 1px solid #E4E7ED !important;
        border-radius: 4px;

    }

    .el-cascader-menu:first-child {
        margin-left: 0.3rem;
    }

    .el-cascader-menu:last-child {
        margin-left: 0.4rem;

        .el-cascader-node__label {
            min-width: 1.73rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    //设置类目表格样式（下三个）
    .el-table th > .cell {
        font-weight: 600;
        font-size: 14px;
        color: #606979;
        opacity: 1;
    }

    .cell {
        font-size: 0.14rem;
        color: #606979;
        opacity: 1;
    }

    //操作删除样式
    .remove {
        font-size: 0.14rem;
        color: #39BEB8;
        opacity: 1;
        cursor: pointer;
    }

    //创建时间组件样式
    .ant-calendar-panel {

        .ant-calendar-input {
            font-size: 0.14rem;

            &::placeholder {
                font-size: 0.14rem;
            }
        }

        .ant-calendar-body, .ant-calendar-today-btn, .ant-calendar-month-select, .ant-calendar-year-select {
            font-size: 0.14rem;
        }
    }

    .ql-editor.ql-blank:before {
        font-size: 0.14rem;
    }

    .OrganizationJoinStep2 {
        margin-top: -0.01rem;

        .stepTop {
            width: 100%;
            display: flex;
            margin-bottom: 0.6rem;
            position: relative;

            img {
                width: 100%;
                height: 1.2rem;
            }

            .rz-type {
                position: absolute;
                left: 4.4rem;
                top: 0.39rem;
                font-size: 0.24rem;
                color: #fff;
                font-weight: bold;
                opacity: 1;
            }
        }

        .progressBar {
            width: 4.5rem;
            height: 1rem;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .form-box {
            padding: 0.3rem 0;
            margin-bottom: 0.7rem;
            /*border: 1px solid red;*/
            .property{
                /*border: 1px solid red;*/
                .ant-form-item-control-wrapper {
                    .ant-form-explain {
                        font-size: 0.14rem;
                        color: #FF4021;
                        opacity: 1;
                        margin-left: 5.7rem;
                        margin-top: -0.3rem;
                    }
                }
            }

            .ant-select-selection__placeholder, .ant-select-selection__choice__content {
                font-size: 0.14rem;
            }

            .ant-checkbox-group-item {
                span {
                    font-size: 0.14rem;
                }

            }

            .tip {
                margin-top: 0.2rem;

                .ant-form-item-label label {
                    font-size: 0.14rem;
                    font-weight: bold;
                    color: #454F63;
                    opacity: 1;
                }

                .ant-form-item-label > label::after {
                    content: '';
                }
            }

            .ant-input {
                font-size: 0.14rem;
                font-weight: 400;
                color: #454F63;
                opacity: 1;
                width: 3.53rem;
                height: 0.4rem;

                &::placeholder {
                    font-size: 0.14rem;
                    font-weight: 400;
                    color: #8F9BA8;
                    opacity: 1;
                }
            }

            .form-item {

                .imageUpload {
                    .ant-form-item-control-wrapper {
                        .ant-form-explain {
                            font-size: 0.14rem;
                            color: #FF4021;
                            opacity: 1;
                            margin-left: 3.7rem;
                            margin-top: -0.8rem;
                        }
                    }

                }

                .admittedObject {
                    .ant-form-item-control-wrapper {
                        .ant-form-explain {
                            width: 3rem;
                            font-size: 0.14rem;
                            color: #FF4021;
                            opacity: 1;
                            margin-left: 0;
                            margin-top: 0;
                        }
                    }
                }

                .abstract1 {

                    .ant-form-item-control-wrapper {
                        .ant-form-explain {
                            width: 3rem;
                            font-size: 0.14rem;
                            color: #FF4021;
                            opacity: 1;
                            margin-left: 6.3rem;
                            margin-top: -0.9rem;
                        }
                    }
                }

                .abstract {
                    margin-top: 1rem;

                    .ant-form-item-control-wrapper {
                        .ant-form-explain {
                            width: 4rem;
                            font-size: 0.14rem;
                            color: #FF4021;
                            opacity: 1;
                            margin-left: 6.3rem;
                        }
                    }
                }

                .ant-form-item-control-wrapper {
                    .ant-form-explain {
                        font-size: 0.14rem;
                        color: #FF4021;
                        opacity: 1;
                        margin-left: 3.7rem;
                        margin-top: -0.33rem;
                    }
                }

                .authCode {
                    position: absolute;
                    top: -0.115rem;
                    left: 2.15rem;
                    height: 0.41rem;

                    button {
                        width: 1.39rem;
                        height: 100%;
                        background: #F5AA21;
                        font-size: 0.14rem;
                        color: #FFFFFF;
                        opacity: 1;
                    }

                    button:hover {
                        border: 1px solid #F5AA21;
                        background: #F5AA21;
                    }

                }

                .ant-upload-list-picture-card .ant-upload-list-item-thumbnail, .ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
                    width: 100%;
                    /*object-fit: contain;*/
                    object-fit: fill;
                    border-radius: 4px;
                }

                .ant-upload-list-picture .ant-upload-list-item, .ant-upload-list-picture-card .ant-upload-list-item {
                    padding: 0;
                }
            }


            .detailsTheData {
                margin: 0 auto;
                width: 10rem;
                /*border: 1px solid red;*/
                display: flex;

                .ant-form-item-control-wrapper {
                    .ant-form-explain {
                        font-size: 0.14rem;
                        color: #FF4021;
                        opacity: 1;
                    }
                }

                .ant-form-item {
                    height: 0.5rem;
                }

                .excursion {
                    width: 6.21rem;
                    /*border: 1px solid red;*/

                    .ant-input-number-input {
                        &::placeholder {
                            font-size: 0.14rem;
                            font-weight: 400;
                            color: #8F9BA8;
                            opacity: 1;
                        }
                    }

                    .ant-input-group {
                        .ant-input {
                            font-size: 0.14rem;
                            font-weight: 400;
                            color: #454F63;
                            opacity: 1;
                            width: 1.67rem;
                            height: 0.4rem;

                            &::placeholder {
                                font-size: 0.14rem;
                                font-weight: 400;
                                color: #8F9BA8;
                                opacity: 1;
                            }


                        }
                    }

                }

                .ant-input {
                    font-size: 0.14rem;
                    font-weight: 400;
                    color: #454F63;
                    opacity: 1;
                    width: 1.67rem;
                    height: 0.4rem;

                    &::placeholder {
                        font-size: 0.14rem;
                        font-weight: 400;
                        color: #8F9BA8;
                        opacity: 1;
                    }


                }
            }


            .present {
                margin-top: 0.8rem;

                button {
                    width: 1.46rem;
                    height: 0.4rem;
                    opacity: 1;
                    border-radius: 0.2rem;
                    font-size: 0.14rem;

                    img {
                        width: 7.75px;
                        height: 13.38px;
                    }
                }

                .button1 {
                    border: 1px solid #78849E;
                    margin-right: 0.5rem;
                    color: #454F63;

                    img {
                        margin-right: 0.07rem;
                    }
                }

                .button2 {
                    color: #FFFFFF;

                    img {
                        width: 14.3px;
                        height: 14px;
                        margin-right: 0.07rem;
                    }
                }
            }

            .ant-cascader-picker-label {
                font-size: 0.14rem;
                font-weight: 400;
                color: #454F63;
                opacity: 1;
            }


            .ant-form-item-label label {
                font-size: 0.14rem;
                font-weight: 400;
                color: #454F63;
                opacity: 1;
            }

            .ant-form-item {
                margin-bottom: 0.2rem;
            }

            .ant-input:hover {
                border-color: #60c7c6;
            }

            .ant-select-selection:hover {
                border-color: #60c7c6;
            }

            .ant-radio-wrapper {
                font-size: 0.14rem;
                font-weight: 400;
                color: #454F63;
                opacity: 1;
            }

            .ant-radio-checked .ant-radio-inner {
                border-color: #60c7c6;
            }

            .ant-checkbox-checked .ant-checkbox-inner {
                background-color: #60c7c6;
                border-color: #60c7c6;
            }

            .ant-radio-inner::after {
                background-color: #60c7c6;
            }

            .ant-btn-primary {
                background-color: #60c7c6;
                border-color: #60c7c6;
            }

            .ant-btn-primary:hover,
            .ant-btn-primary:focus {
                background-color: #60c7c6;
                border-color: #60c7c6;
            }
        }

        .fileTipBox202005062 {
            position: absolute;
            font-size: 0.14rem;
            font-weight: 400;
            color: #a9a9a9;
            opacity: 1;
            top: 0.33rem;
            display: flex;
            align-items: center;
            height: 0.2rem;
            width: 9rem;
        }

        #fwts {
            max-width: 7rem;

            .feature {
                min-width: 3.53rem;
                height: 100%;
                margin-left: 0.8rem;

                .tdajosnBox {
                    width: 100%;
                    height: 0.4rem;
                    display: flex;
                    align-items: center;
                    margin-bottom: 0.12rem;

                    .span1 {
                        font-size: 0.14rem;
                        color: #454F63;
                        opacity: 1;
                        display: inline-block;
                        width: 1rem;
                        /*overflow: hidden;*/
                        /*border: 1px solid red;*/
                    }

                    .span2 {
                        margin-left: 0.3rem;
                        font-size: 0.14rem;
                        color: #454F63;
                        opacity: 1;
                    }
                }
            }
        }

    }
</style>
